import IvrsAPI from 'dashboard/api/asterisk/ivrs';
import { createHandleRealtimeEvent } from './_helpers/asteriskRealtime';
import { createPendingOp } from './_helpers/asteriskAsyncOp';

const RESOURCE = 'ivr';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getById: $state => id =>
    $state.records.find(r => r.id === id || r.id === String(id)),
};

export const actions = {
  // Recebe broadcast ActionCable disparado pelo ApiCallJob (IvrsService) e
  // resolve a Promise pendente do create/update/delete via resolvePendingOp.
  handleRealtimeEvent: createHandleRealtimeEvent('fetch', RESOURCE),

  async fetch({ commit }, { excludeSubmenus = false } = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const params = excludeSubmenus ? { exclude_submenus: true } : {};
      const response = await IvrsAPI.get(params);
      const data = response.data;
      const ivrs = data.ivrs || data.data || [];
      commit('SET_RECORDS', ivrs);
      return ivrs;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async show(_, id) {
    const response = await IvrsAPI.show(id);
    return response.data.ivr || response.data.data || response.data;
  },

  // Backend retorna 202 (job enfileirado). Promise resolve quando broadcast
  // `asterisk.ivr.changed` confirma — permite toast.promise no form.
  async create({ commit }, data) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      await IvrsAPI.create(data);
      await createPendingOp(RESOURCE, 'created', null);
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      await IvrsAPI.update(id, data);
      await createPendingOp(RESOURCE, 'updated', id);
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await IvrsAPI.delete(id);
      await createPendingOp(RESOURCE, 'deleted', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  SET_RECORDS($state, records) {
    $state.records = records;
  },

  ADD_RECORD($state, record) {
    $state.records.push(record);
  },

  UPDATE_RECORD($state, { id, data }) {
    const index = $state.records.findIndex(
      r => r.id === id || r.id === String(id)
    );
    if (index !== -1) {
      $state.records.splice(index, 1, { ...$state.records[index], ...data });
    }
  },

  DELETE_RECORD($state, id) {
    $state.records = $state.records.filter(
      r => r.id !== id && r.id !== String(id)
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
